import React, { memo, SVGProps } from 'react';

const IllustrationLineBottom = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="438"
			height="562"
			viewBox="0 0 438 562"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<defs>
				<mask id="theMaskBottomImage" maskUnits="userSpaceOnUse">
					<path
						id="illustration-line-bottom"
						d="M1 561C14.5 265 45.5718 111.49 189.5 146.5C430 205 497.5 35.5 381.5 1"
						stroke="#FFFFFF"
						strokeWidth="2"
					/>
				</mask>
			</defs>

			<g id="maskReveal" mask="url(#theMaskBottomImage)">
				<path
					d="M1 561C14.5 265 45.5718 111.49 189.5 146.5C430 205 497.5 35.5 381.5 1"
					stroke="url(#paint0_linear_1636_39248)"
					strokeWidth="2"
					strokeLinecap="round"
					strokeDasharray="16 16"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_1636_39248"
						x1="43.5"
						y1="389"
						x2="5.94257"
						y2="538.844"
						gradientUnits="userSpaceOnUse"
					>
						<stop stopColor="#FF8541" />
						<stop offset="1" stopColor="#FF8541" stopOpacity="0" />
					</linearGradient>
				</defs>
			</g>
		</svg>
	);
};

export default memo(IllustrationLineBottom);
